import { MRT_ColumnDef } from 'mantine-react-table'
import { Text, Avatar, Group } from '@mantine/core'
import { ReactNode } from 'react'
import getInitials from 'app/views/components/functions/getInitials'

function TableHead({ header }: { header: string }) {
  return (
    <Text
      style={{
        fontFamily: 'Plus Jakarta Sans',
        fontSize: '1.5em',
      }}
    >
      {header}
    </Text>
  )
}

function TableRowText({ text }: { text: ReactNode }) {
  return (
    <Text
      style={{
        fontFamily: 'Plus Jakarta Sans',
        fontSize: '1.5em',
      }}
    >
      {text}
    </Text>
  )
}

export const userManagementCols: MRT_ColumnDef<any>[] = [
  {
    accessorKey: 'fullName',
    header: 'Full Name',
    Header: <TableHead header={'Full Name'} />,
    size: 150,
    Cell: ({ cell }) => (
      <Group>
        <Avatar radius="xl" color="cyan" size="2.5em">
          {getInitials(cell.getValue<string>())}
        </Avatar>
        <span style={{ fontSize: '1.5em' }}>{cell.getValue<string>()}</span>
      </Group>
    ),
  },
  {
    size: 100,
    accessorKey: 'username',
    header: 'Username',
    Header: <TableHead header={'Username'} />,
    Cell: ({ cell }) => <TableRowText text={cell.getValue<string>()} />,
  },
  {
    size: 150,
    accessorKey: 'email',
    header: 'Email',
    Header: <TableHead header={'Email'} />,
    Cell: ({ cell }) => <TableRowText text={cell.getValue<string>()} />,
  },
  {
    size: 100,
    accessorKey: 'role',
    header: 'Role',
    Header: <TableHead header={'Role'} />,
    Cell: ({ cell }) => <TableRowText text={cell.getValue<string>() ?? '—'} />,
  },
  {
    size: 100,
    accessorKey: 'accessLevel',
    header: 'Access Level',
    Header: <TableHead header={'Access Level'} />,
    Cell: ({ cell }) => <TableRowText text={cell.getValue<string>() ?? '—'} />,
  },
  {
    size: 100,
    accessorKey: 'status',
    header: 'Status',
    Header: <TableHead header={'Status'} />,
    Cell: ({ cell }) => <TableRowText text={cell.getValue<string>()} />,
  },
  {
    size: 120,
    accessorKey: 'company',
    header: 'Company',
    Header: <TableHead header={'Company'} />,
    Cell: ({ cell }) => <TableRowText text={cell.getValue<string>()} />,
  },
]
